<template>
  <div>
    <label class="mt-2" for="userInfo">{{$t('AddressBook.search_autocomplete')}}</label>
    <vue-google-autocomplete
      class="form-control border"
      id="userInfo"
      ref="AutocompleteUserInfo"
      :placeholder="$t('AddressBook.search_autocomplete')"
      v-on:placechanged="getAddressData"
      :country="['ca', 'us']"
      :fields="autocompleteSearchFields">
    </vue-google-autocomplete>
  </div>
</template>

<script>
import RegularInput from '../../basic-components/regularInput.vue'
import VueGoogleAutocomplete from 'vue-google-autocomplete'

export default {
  components: {
    RegularInput,
    VueGoogleAutocomplete
  },
  props: {
    accountInfo: Object // Base object data
  },
  data () {
    return {
      userInfo: {
        name: '',
        address: '',
        postcode: '',
        phone: '',
        city: '',
        province: '',
        country: ''
      },
      isGoogleInfoEmpty: {
        address: false,
        city: false,
        postcode: false,
        province: false
      },
      autocompleteSearchFields: ['address_components', 'adr_address', 'formatted_address', 'formatted_phone_number', 'geometry', 'id', 'name', 'place_id', 'type', 'vicinity']
      // 'utc_offset_minutes', 'url', 'photo', 'business_status', 'icon', 'scope', 'alt_id',}
    }
  },

  created () {
    this.userInfo = this.accountInfo
  },

  methods: {
    getAddressData (addressData, placeResultData) {
      this.clearInputInfo()

      const nameOfThisPlace = placeResultData.name
      let nameUsed = ''
      if (!nameOfThisPlace.includes(placeResultData.formatted_address.split(',')[0])) {
        nameUsed = placeResultData.name
      }

      this.userInfo.name = nameUsed || ''
      this.userInfo.address = placeResultData.formatted_address.split(',')[0] || ''
      this.userInfo.postcode = addressData.postal_code || ''
      this.userInfo.phone = placeResultData.formatted_phone_number || ''
      this.userInfo.city = addressData.locality || ''
      this.userInfo.province = addressData.administrative_area_level_1 || ''
      this.userInfo.country = addressData.country || ''
      // this.userInfo.placeId = placeResultData.place_id || ''
      // this.userInfo.lat = addressData.latitude || ''
      // this.userInfo.long = addressData.longitude || ''

      this.checkInputInfo()
      this.emitIsGoogleInfoEmpty()
    },

    clearInputInfo () {
      this.userInfo.name = ''
      this.userInfo.address = ''
      this.userInfo.postcode = ''
      this.userInfo.phone = ''
      this.userInfo.city = ''
      this.userInfo.province = ''
      this.userInfo.country = ''
      // this.userInfo.placeId = ''
      // this.userInfo.lat = 0
      // this.userInfo.long = 0
    },

    checkInputInfo () {
      if (this.userInfo.address !== '') this.isGoogleInfoEmpty.address = true
      else this.isGoogleInfoEmpty.address = false

      if (this.userInfo.postcode !== '') this.isGoogleInfoEmpty.postcode = true
      else this.isGoogleInfoEmpty.postcode = false

      if (this.userInfo.city !== '') this.isGoogleInfoEmpty.city = true
      else this.isGoogleInfoEmpty.city = false

      if (this.userInfo.province !== '') this.isGoogleInfoEmpty.province = true
      else this.isGoogleInfoEmpty.province = false

      if (this.userInfo.country !== '') this.isGoogleInfoEmpty.country = true
      else this.isGoogleInfoEmpty.country = false
    },

    emitIsGoogleInfoEmpty () {
      this.$emit('updateEmptyGoogleFields', this.isGoogleInfoEmpty)
    }
  }
}
</script>

<style scoped>
</style>
